import React, { ReactNode } from 'react';
import { useThemeContext } from 'src/context/ThemeProvider';

interface Props {
	content: ReactNode;
}

const SkillBadge = ({ content }: Props) => {
	const { themeMode } = useThemeContext();
	return (
		<>
			<div
				className="py-[2px] px-[10px] w-max rounded-[4px] dark:bg-[#242C40] text-[10px] font-medium text-[#7777E7] dark:text-[#E4E4EB] border-[0.5px] border-solid border-transparent dark:border-[#A9EFF2]"
				style={{
					background:
						themeMode === 'dark'
							? ''
							: 'linear-gradient(white, white) padding-box, linear-gradient(147.14deg, #73dfe7 6.95%, #0063f7 93.05%) border-box',
				}}
			>
				{content}
			</div>
		</>
	);
};

export default SkillBadge;
